import { useData } from 'vike-react/useData'
import { usePageContext } from 'vike-react/usePageContext'
import type { Data } from './+data'
import ProductListSeoHead from '../../src/ssr/products/ProductListSeoHead'
import SsrProductListView from '../../src/ssr/products/SsrProductListView'

export default function ProductsSsrPage() {
  const { lang, search, products, productTotal, facets, initialQueryString } = useData<Data>()
  const pageContext = usePageContext()
  const origin =
    typeof window === 'undefined'
      ? (process.env.PUBLIC_ORIGIN ?? 'https://shop.globalcontrol.group')
      : window.location.origin
  const canonical = origin + new URL(pageContext.urlOriginal, origin).pathname

  return (
    <>
      <ProductListSeoHead
        lang={lang}
        productTotal={productTotal}
        canonical={canonical}
        search={search}
      />
      <SsrProductListView
        lang={lang}
        products={products}
        productTotal={productTotal}
        facets={facets}
        initialQueryString={initialQueryString}
      />
    </>
  )
}
